function getBoundaryTypeList () {
    return [
        {boundaryTypeId: 1, description: 'Feature/Artifact distribution'},
        {boundaryTypeId: 2, description: 'Modern features or disturbance'},
        {boundaryTypeId: 3, description: 'Property boundaries'},
        {boundaryTypeId: 4, description: 'Topography'},
        {boundaryTypeId: 5, description: 'Other'},
        {boundaryTypeId: 6, description: 'Unknown'}
    ]
}

function getPropertyDescription (http, propertyDescriptionId) {
    return http.get('/PropertyDescription/Get?propertyDescriptionId=' + propertyDescriptionId)
}

function putPropertyDescription (http, propertyDescription) {
    return http.put('/PropertyDescription/', propertyDescription)
}

function searchPropertyDescription (http, searchDto) {
    return http.post('/PropertyDescription/Search', searchDto)
}

function getPropertyBoundary (http, propertyBoundaryId) {
    return http.get('/PropertyBoundary/Get?propertyBoundaryId=' + propertyBoundaryId)
}

function putPropertyBoundary (http, propertyBoundaryDto) {
    return http.put('/PropertyBoundary/', propertyBoundaryDto)
}

function searchPropertyBoundary (http, searchDto) {
    return http.post('/PropertyBoundary/Search/', searchDto)
}

export default {
    getBoundaryTypeList: getBoundaryTypeList,

    getPropertyDescription: getPropertyDescription,
    putPropertyDescription: putPropertyDescription,
    searchPropertyDescription: searchPropertyDescription,

    getPropertyBoundary: getPropertyBoundary,
    putPropertyBoundary: putPropertyBoundary,
    searchPropertyBoundary: searchPropertyBoundary
}



// WEBPACK FOOTER //
// ./src/services/siteForm/propertyDescriptionService.js